import React, { ReactElement } from "react";
import { Tabs } from "@mantine/core";
import { IconSquareFilled } from "@tabler/icons-react";
import styles from "./AddressDetailsTabs.module.scss";
import TransactionTab from "./TransactionTab.component";
import PendingTab from "./PendingTab.component";
import UnspentTab from "./UnspentTab.component";
import Button from "../Button/Button.component";
import { useParams, useSearchParams } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import ExportCSVModal from "../ExportCSV/exportCSVModal/exportCSVModal.component";
import CChainTabComponent from "./CChainTab.component";

export enum TabType {
  confirmed = "confirmed",
  pending = "pending",
  unspent = "unspent",
  cChain = "c-chain"
}

export default function AddressDetailsTabs(): ReactElement | null {
  const { address } = useParams();
  const [opened, { open, close }] = useDisclosure();
  const [searchParams, setSearchParams] = useSearchParams();

  const validTabs = new Set(Object.values(TabType));
  const tabFromQuery = searchParams.get("tab");
  const activeTab = validTabs.has(tabFromQuery as TabType) ? (tabFromQuery as TabType) : TabType.confirmed;

  const handleTabChange = (value: string | null) => {
    if (value) {
      setSearchParams({ tab: value });
    }
  };


  return (
    <>
      <Tabs
        variant="default"
        color="orange"
        defaultValue="confirmed"
        h={710}
        value={activeTab}
        onChange={(value) => handleTabChange(value as TabType)}
      >
        <Tabs.List pr={100}>
          <Tabs.Tab
            value="confirmed"
            leftSection={<IconSquareFilled className={styles.icon} />}
          >
            <span className={styles.tabTitle}>P-Chain</span>
          </Tabs.Tab>

          {process.env.REACT_APP_CHAIN?.toLowerCase() === "flr" && (
            <Tabs.Tab
              value="c-chain"
              leftSection={<IconSquareFilled className={styles.icon} />}
            >
              <span className={styles.tabTitle}>C-Chain</span>
            </Tabs.Tab>
          )}

          <Tabs.Tab
            value="pending"
            leftSection={<IconSquareFilled className={styles.icon} />}
          >
            <span className={styles.tabTitle}>Pending cross-chain</span>
          </Tabs.Tab>

          <Tabs.Tab
            value="unspent"
            leftSection={<IconSquareFilled className={styles.icon} />}
          >
            <span className={styles.tabTitle}>Unspent outputs</span>
          </Tabs.Tab>

          {(activeTab === TabType.confirmed || activeTab === TabType.cChain) && (
            <div className={styles.exportButtonWrapper}>
              <Button onClick={open} addStyles={["basic", "compact"]}>
                Export CSV
              </Button>
            </div>
          )}
        </Tabs.List>

        <Tabs.Panel value="confirmed">
          <TransactionTab active={activeTab === TabType.confirmed} />
        </Tabs.Panel>

        {process.env.REACT_APP_CHAIN?.toLowerCase() === "flr" && (
          <Tabs.Panel value="c-chain">
            <CChainTabComponent active={activeTab === TabType.cChain} />
          </Tabs.Panel>
        )}

        <Tabs.Panel value="pending">
          <PendingTab active={activeTab === TabType.pending} />
        </Tabs.Panel>

        <Tabs.Panel value="unspent">
          <UnspentTab active={activeTab === TabType.unspent} />
        </Tabs.Panel>
      </Tabs>

      <ExportCSVModal tnxCategory={activeTab} opened={opened} onClose={close} address={address} />
    </>
  );
}
